import React, { useEffect } from 'react';

import { LockOutlined } from '@ant-design/icons';
import { Form, Input, Alert } from 'antd';
import { useTranslation } from 'react-i18next';

const ShopeeCredentials = ({ form, ecAccount }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (ecAccount?.credentials) {
      let creds = ecAccount.credentials;
      if (typeof creds === 'string') {
        try {
          creds = JSON.parse(creds);
        } catch (e) {
          console.error('Failed to parse credentials:', e);
          creds = {};
        }
      }

      const currentValues = form.getFieldsValue(true);
      form.setFieldsValue({
        credentials: {
          ...currentValues.credentials,
          ...creds
        }
      });
    }
  }, [ecAccount]);

  const credentials = form.getFieldValue('credentials') || {};
  const isAuthorized = !!credentials.access_token;

  return (
    <div>
      {isAuthorized && (
        <Alert
          message={credentials.shop_id
            ? t('models.ec_account.platform_settings.shopee.authorized_with_shop_id', { shop_id: credentials.shop_id })
            : t('models.ec_account.platform_settings.shopee.authorized')
          }
          type="success"
          showIcon
          icon={<LockOutlined />}
        />
      )}

      {/* 隱藏欄位，用於註冊到 Form 讓 useWatch/dependencies 能偵測到 */}
      <Form.Item name={['credentials', 'access_token']} hidden>
        <Input />
      </Form.Item>
    </div>
  );
};

export default ShopeeCredentials;
